// v1's phone validation, ported: after the shape check, the number is
// verified against our validation endpoint — debounced, cached, and
// failing open so an outage never blocks a customer.

import { fetchPublicAPI } from "hooks/usePublicAPI";

function toE164(value: string): string {
  const digits = value.replace(/\D/g, "");
  return `+1${digits}`;
}

let timeoutId: number | null = null;
const cache: Record<string, boolean> = {};

/** Resolves true when the number is real, else an error message. */
export function checkPhoneNumberIsReal(value: string): Promise<string | true> {
  return new Promise((resolve) => {
    const formatted = toE164(value);
    const cached = cache[formatted];
    if (cached !== undefined) {
      resolve(cached ? true : "That phone number doesn't look real");
      return;
    }
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = window.setTimeout(async () => {
      try {
        const data = await fetchPublicAPI<{ valid: boolean }>(
          `/validation/phones/${formatted}`,
        );
        cache[formatted] = data.valid;
        resolve(data.valid ? true : "That phone number doesn't look real");
      } catch {
        // Fail open — an outage must never block a customer.
        resolve(true);
      }
    }, 300);
  });
}
